const getAnalyticsEventCenter = require('../../common/getAnalyticsEventCenter');
const getBaseConfig = require('../../common/getBaseConfig');
const cookieHelper = require('../../utilities/cookie');
const { setExitObserver } = require('../exitObserver');
const { createIdleObserver } = require('../idleObserver');
const { isAnonymousCustomer } = require('../analytics/abandonedCart');
const modalFactory = require('./modalFactory');

const analyticsEventCenter = getAnalyticsEventCenter();
const BASE_CONFIG = getBaseConfig();

/**
 * Sets observers for idle and exit intents
 */
function createObservers() {
    const idleTime = BASE_CONFIG.abandonedCartConfig.idleTime;
    createIdleObserver({
        idleTime,
        keepTracking: true,
        onIdle: () => {
            analyticsEventCenter.publish(
                analyticsEventCenter.EVENTS.userInteractionStopped,
                {
                    millisecondsSinceLastAction: idleTime,
                    source: analyticsEventCenter.PAYLOADS.userInteractionStopped
                        .source.abandonedCartModal
                }
            );
        }
    });

    const useExitObservers = BASE_CONFIG.abandonedCartConfig.useExitObservers;
    if (useExitObservers) {
        setExitObserver();
    }
}

const guestModalClosedCookie = {
    exists: () => !!cookieHelper.getCookieValue(
        modalFactory.config.GUEST_MODAL_CLOSED_COOKIE_NAME
    ),
    /**
     * Sets a cookie to know Abandoned cart Modal has been
     *  closed or form has been completed in the given time
     */
    set: function setAbandonedCartCookie() {
        const expiringTime = BASE_CONFIG.abandonedCartConfig.cookieExpiringTime;
        const expiringTimeinMiliseconds = expiringTime * 60 * 60 * 1000;
        const date = new Date();
        date.setTime(date.getTime() + expiringTimeinMiliseconds);
        cookieHelper.setCookie(
            modalFactory.config.GUEST_MODAL_CLOSED_COOKIE_NAME,
            'true',
            date.toUTCString()
        );
    }
};

/**
 * Subscribe to Idle event
 *
 * @param {modalFactory.ModalComponentInstance} modalComponentInstance The modal component
 */
function subscribeToIdleEvent(modalComponentInstance) {
    analyticsEventCenter.subscribe(
        analyticsEventCenter.EVENTS.userInteractionStopped,
        /**
         * Handle when user interaction stops due to idle state
         * @param {Object} payload The event payload
         * @param {number} [payload.millisecondsSinceLastAction] The milliseconds
         *  since last action. This is useful because the event can be configured
         *  to be used for diferent idle times. There is no a common config. For
         *  instance: Abandoned Cart modal publishes it according a custom site
         *  preference named `adAcIdleTime`.
         * @param {string} [payload.source] Optional identifier of the
         *  feature/observer that emitted the event (e.g., "abandonedCart",
         *  "sessionTimeout", "globalIdle"). Helps consumers decide whether to act.
         */
        ({ source }) => {
            if (
                source
                === analyticsEventCenter.PAYLOADS.userInteractionStopped.source
                    .abandonedCartModal
            ) {
                modalComponentInstance.open();
            }
        },
        false
    );
}

/**
 * Subscribe to Exit intent event
 *
 * @param {modalFactory.ModalComponentInstance} modalComponentInstance The modal component
 */
function subscribeToExitIntent(modalComponentInstance) {
    analyticsEventCenter.subscribe(
        analyticsEventCenter.EVENTS.userExitIntentAttempted,
        () => {
            modalComponentInstance.open();
        },
        false
    );
}

const guestModal = modalFactory.createModalComponent({
    ID: modalFactory.config.MODAL_GUEST_ID,
    beforeCloseFn() {
        guestModalClosedCookie.set();
        // Clear form
        this.setEmail('');
    },
    closeFn() {
        $(`#${modalFactory.config.MODAL_GUEST_ID}`).modal('hide');
    },
    initializeFn() {
        const modalComponentInstance = this;
        createObservers();
        subscribeToIdleEvent(modalComponentInstance);
        subscribeToExitIntent(modalComponentInstance);
        analyticsEventCenter.subscribe(
            analyticsEventCenter.EVENTS.checkoutError,
            ({ stageName }) => {
                if (stageName === 'payment' || stageName === 'placeOrder') {
                    modalComponentInstance.open();
                }
            },
            false
        );
    },
    isEnabledFn() {
        let isEnabled = false;
        const modalEnabled = BASE_CONFIG.abandonedCartConfig.modalEnabled;
        const sfmcCollectEnabled = BASE_CONFIG.sfmc.collectEnabled;
        isEnabled = sfmcCollectEnabled && modalEnabled;
        if (isEnabled) {
            const isRegisteredUser = document
                .getElementById(modalFactory.config.MODAL_GUEST_ID)
                ?.getAttribute('data-registered-user') === 'true';
            // Enabled only for guest users
            isEnabled = !isRegisteredUser;
        }
        return isEnabled;
    },
    openFn() {
        // Show Abandoned cart modal
        const abandonedCartModal = document.getElementById(
            modalFactory.config.MODAL_GUEST_ID
        );
        $(abandonedCartModal).modal('show');
    },
    async shouldOpenAsyncFn() {
        const consentModalInstance = require('./consentModal');

        let shouldOpen = !guestModalClosedCookie.exists()
             && !consentModalInstance.isOpen();

        if (shouldOpen) {
            const isCheckout = !!document.querySelector('.checkout-page');
            const isEmptyCart = document.querySelectorAll('.cart-content .product-card')
                ?.length <= 0 ?? true;
            shouldOpen = isCheckout || !isEmptyCart;
        }
        return shouldOpen && isAnonymousCustomer();
    }
});

module.exports = guestModal;
